<template>
    <div>
        <!-- 頁首 -->
        <div class="header-pwa">
            <div class="header-pwa-title">

                <!-- 左邊圖示-設定 -->
                <div class="header-left" @click="onSetting()">
                    <i class="fa-solid fa-gear"></i>
                </div>

                <!-- 中間標題 -->
                <div class="header-pwa-home">
                    <!-- 圖示 -->
                    <img :src="src"  :alt="alt">
                    <!-- 標題 -->
                    <div class="header-title">{{ title }}</div>
                </div>

                <!-- 右邊圖示-鈴鐺(最新訊息)_-->
                <NotificationBell ref="notificationBell"></NotificationBell>

            </div>
        </div>

        <!-- 主體 -->
        <div class="index mainContent">

            <!-- 跑馬燈 -->
            <div v-if="marquee.list.length > 0" class="marquee-container">
                <Marquee
                    mode="horizontal"
                    :items="marquee.list"
                    :speed="marqueeSpeed"
                />
            </div>

            <!-- 氣象在地服務專區 -->
            <div class="weather-viewer-pwa">
                <b-container>
                    <PwaTitle :textTitle="weather.title" :showMore="weather.more" @clickMore="moreWeather()" ></PwaTitle>
                    <b-row>
                        <!-- 縣市、日期、天氣資訊(降雨機率、最低溫、最高溫) -->
                        <b-col cols="4">
                            <div class="weather-info">
                                <!-- 縣市、日期 -->
                                <div class="weather-info-top">
                                    <!-- 縣市 -->
                                    <span class="weather-info-place">{{ weather.place }}</span>
                                    <!-- 日期 -->
                                    <span class="weather-info-date">{{ weather.date }}</span>
                                </div>
                                <!-- 天氣資訊(降雨機率、最低溫、最高溫) -->
                                <div class="weather-info-num">
                                    <!-- 天氣資訊(降雨機率) -->
                                    <div><span class="icon-rain mr-1"></span><span>{{ weather.pop }}%</span></div>
                                    <!-- 天氣資訊(最低溫、最高溫) -->
                                    <div><span class="icon-thermometer-hot mr-1"></span><span class="num">{{ weather.t_min }}-{{ weather.t_max }}℃</span></div>
                                </div>
                            </div>
                        </b-col>
                        <!-- 天氣(注意、預警) -->
                        <b-col cols="8" class="weather-alert-info shadow-sm">
                            <!-- 輪播 -->
                            <b-row>
                                <carousel :autoplay="false" :margin="10" :loop="false" :dots="false" :nav="false" style="width: 100%;" :responsive="{ 0:{items: 2}, 768:{items: 2}, 992:{items: 2} }" v-if="weather_alert.list.length > 0 ">
                                    <b-col v-for="(item, index) in weather_alert.list" :key="index" style="width:100%">
                                        <button class="btn btn-block" :class="weather_alert.select === item.disaster?(item.color == 'danger' ? 'btn-red active' : 'btn-yellow active'):(item.color == 'danger' ? 'btn-red' : 'btn-yellow')"
                                            @click="setWeatherAlertSelect(item.disaster, 'data')">{{ item.disaster }}</button>
                                    </b-col>
                                </carousel>
                            </b-row>
                            <!-- 資料來源網址 -->
                            <DataSource :href="weather_alert.source.href" :text="weather_alert.source.title"></DataSource>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <p class="global-paragraph">&nbsp;</p>

            <!-- 智慧農業成果 -->
            <div class="agri-result-group pwa pb-1">
                <b-container>
                    <PwaTitle :textTitle="wisdom_agri.title" :showMore="wisdom_agri.more" @clickMore="moreWisdomFarm()" ></PwaTitle>
                    <div class="">
                        <!-- 輪播 -->
                        <carousel
                            :key="wisdom_agri.list.length"
                            :autoplay="false" :margin="10" :loop="false" :nav="false" :dots="false" :responsive="{0:{items: 3},768:{items: 3},992:{items: 4}}" v-if="wisdom_agri.list.length > 0 ">
                            <div v-for="(item, index) in wisdom_agri.list" :key="index">
                                <div @click="setWisdomAgriResultSelect(item)" class="agri-result-item drop-shadow">
                                    <!-- 相片 -->
                                    <div class="agri-result-pic">
                                        <b-img :src="item.src"  fluid></b-img>
                                    </div>
                                    <!-- 標題 -->
                                    <div class="agri-result-info" style="display: flex; align-items: center; justify-content: center;min-height: 3.5rem;">
                                        <h3 class="agri-result-title">{{ item.title }}</h3>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </b-container>

            </div>
            <p class="global-paragraph">&nbsp;</p>

            <!-- 智慧農場 -->

            <!-- 農價趨勢觀察家 -->
            <div class="price-group-pwa">
                <b-container>
                    <!-- 標題與切換按鈕同一列 -->
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <PwaTitle :textTitle="price.title" :showMore="price.more" @clickMore="morePrice()" ></PwaTitle>
                        <!-- 切換按鈕 -->
                        <div class="d-flex" v-if="price.subscriptionList.length > 0" style="gap: 5px;">
                            <button
                                class="btn btn-sm"
                                :class="price.displayMode === 'all' ? 'btn-primary' : 'btn-outline-primary'"
                                @click="price.displayMode = 'all'">
                                全部作物
                            </button>
                            <button
                                class="btn btn-sm"
                                :class="price.displayMode === 'subscription' ? 'btn-success' : 'btn-outline-success'"
                                @click="price.displayMode = 'subscription'">
                                個人訂閱
                            </button>
                        </div>
                    </div>
                    <div class="p-2">

                        <b-row cols="2" class="pb-2">
                            <b-col class="up-price">
                                <div class="price-item-title">
                                    {{ price.up.title }}
                                </div>
                                <div class="price-item shadow-sm">
                                    <!-- 全部作物模式 -->
                                    <div class="price-item-block scrollStyle" v-if="price.displayMode === 'all'">
                                        <div class="price-list" v-for="(item, index) in price.up.list" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}元/公斤</div>
                                        </div>
                                    </div>
                                    <!-- 個人訂閱模式 -->
                                    <div class="price-item-block scrollStyle" v-else>
                                        <div class="price-list" v-for="(item, index) in price.subscribedUpList" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}元/公斤</div>
                                        </div>
                                        <div v-if="price.subscribedUpList.length === 0" class="text-center py-3 text-muted">
                                            目前沒有訂閱的漲勢作物
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col class="down-price">
                                    <div class="price-item-title">
                                        {{ price.down.title }}
                                    </div>
                                <div class="price-item shadow-sm">
                                    <!-- 全部作物模式 -->
                                    <div class="price-item-block scrollStyle" v-if="price.displayMode === 'all'">
                                        <div class="price-list" v-for="(item, index) in price.down.list" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}/公斤</div>
                                        </div>
                                    </div>
                                    <!-- 個人訂閱模式 -->
                                    <div class="price-item-block scrollStyle" v-else>
                                        <div class="price-list" v-for="(item, index) in price.subscribedDownList" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}/公斤</div>
                                        </div>
                                        <div v-if="price.subscribedDownList.length === 0" class="text-center py-3 text-muted">
                                            目前沒有訂閱的跌勢作物
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <ul class="mb-0 text-shadow-white list-unstyled">
                            <li class="global-descript">漲跌勢判斷以RSV>80為漲勢、&lt;20為跌勢</li>
                            <li class="global-descript">RSV=((加權平均-最近9日最低均價) /(最近9天最高均價-最近9天最低價))*100[*RSV指未成熟隨機值]</li>
                        </ul>
                        <!-- 資料來源網址 -->
                        <DataSource :href="price.source.href" :text="price.source.title"></DataSource>
                    </div>
                </b-container>

            </div>
            <p class="global-paragraph">&nbsp;</p>

            <!-- 最新消息 -->
            <div class="news-pwa" v-if="news.list.length > 0">
                <b-container>
                    <PwaTitle :textTitle="news.title" :showMore="news.more" ></PwaTitle>
                    <div class="">
                        <!-- 輪播 -->
                        <carousel :autoplay="false" :margin="10" :loop="true" :nav="false" :dots="false" :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}" v-if="news.list.length > 0 ">
                            <div v-for="(item, index) in news.list" :key="index">
                                <b-link :href="item.url" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="agri-result-item drop-shadow" >
                                    <div class="agri-result-pic">
                                        <b-img :src="item.src"  fluid></b-img>
                                    </div>
                                </b-link>
                            </div>
                        </carousel>
                    </div>
                </b-container>
            </div>
            <p class="global-paragraph">&nbsp;</p>

            <!-- 彈出視窗(作物預警) -->
            <ModalWindow
                :show="modal.crop_alert.show"
                :textTitle="weather_alert.select"
                :maxWidth="'720px'"
                @ClickClose="modal.crop_alert.show = false;">

                <div class="alert-msg-group" v-for="(item, index) in weather_alert.list" :key="index" v-show="weather_alert.select === item.disaster && modal.crop_alert.show">

                    <div class="alert-msg-main">
                        <div class="alert-msg-btn">
                            <carousel :autoplay="false" :loop="false" :nav="false" :dots="false" style="width: 100%;" v-if="item.datas"
                                :responsive="{0:{items: 2},335:{items: 2},435:{items: 2},535:{items: 3},735:{items: 3},935:{items: 4},1035:{items: 5}}">
                                <button class="btn btn-round" style="width:8.5rem" :class="index_detail == modal.crop_alert.index?(item.color == 'warning' ? 'btn-yellow active' : 'btn-red active'):(item.color == 'warning' ? 'btn-yellow  ' : 'btn-red ')"
                                    v-for="(item_detail, index_detail) in item.datas" :key="index_detail"
                                    @click="setWeatherAlertSelect(index_detail, 'detail')">{{ item_detail.crop.length > 5 ? item_detail.crop.substring(0, 3) + '...' : item_detail.crop }}</button>
                            </carousel>
                        </div>
                        <div class="container" v-for="(item_detail, index_detail) in item.datas" :key="index_detail" v-show="index_detail == modal.crop_alert.index">
                            <div class="global-title title">{{ item_detail.crop }}</div>
                            <p class="global-descript" v-if="item_detail.time != ''"><span class="mark">警戒時間:</span><br />{{ item_detail.time }}。</p>
                            <p class="global-descript"><span class="mark">警戒門檻:</span><br />{{ getCropAlertThreshold(item_detail) }}。</p>
                            <p class="global-descript" v-if="item_detail.effect != ''"><span class="mark">可能影響:</span><br />{{ item_detail.effect }}</p>
                            <p class="global-descript" v-if="item_detail.prevention != ''"><span class="mark">防範建議:</span><br />{{ item_detail.prevention }}</p>
                            <p class="global-descript" v-if="item_detail.recovery != ''"><span class="mark">復耕建議:</span><br />{{ item_detail.recovery }}</p>
                        </div>
                    </div>
                </div>
            </ModalWindow>

            <!-- 彈出視窗(9日交易均價及成交量) -->
            <ModalWindow
                :show="modal.trade_price.show"
                :textTitle="modal.trade_price.crop"
                :textDescription="'近9日交易均價及成交量。'"
                :maxWidth="'800px'"
                @ClickClose="modal.trade_price.show = false;">

                <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                    <div id="chart_crop_trade_day9"></div>
                </div>
            </ModalWindow>

            <!-- 彈出視窗(天氣小幫手描述) -->
            <ModalWindow
                :show="modal.open_weather_data.show"
                :textTitle="modal.open_weather_data.title"
                :textDescription="modal.open_weather_data.content"
                :maxWidth="'600px'"
                @ClickClose="modal.open_weather_data.show = false;">
            </ModalWindow>

            <!-- 彈出視窗(智慧農場) -->
            <ModalWindow
                :show="modal.wisdom_farm.show"
                :textTitle="wisdom_farm.select.title"
                :textDescription="modal.wisdom_farm.content"
                :maxWidth="'600px'"
                @ClickClose="modal.wisdom_farm.show = false;">


                <!-- 輪播 -->
                <carousel
                    :key="wisdom_farm.select.list.length"
                    :autoplay="false"
                    :margin="10"
                    :loop="false"
                    :nav="false"
                    :dots="true"
                    :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}"
                    v-if="wisdom_farm.select.list != null && wisdom_farm.select.list.length > 0 ">

                        <div v-for="(item_farm, index_farm) in wisdom_farm.select.list" :key="index_farm">
                            <div class="agri-result-item drop-shadow">
                                <!-- 固定高度的容器 -->
                                <div class="carousel-pic">
                                    <b-img
                                    :src="'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + wisdom_farm.select.sn + '/' + item_farm.src"
                                    fluid
                                    ></b-img>
                                </div>
                            </div>
                        </div>

                </carousel>
                <div class="global-descript" style="padding-bottom: 20px;">{{ wisdom_farm.select.descript }}</div>

            </ModalWindow>

            <!-- 彈出視窗(智慧農業成果) -->
            <ModalWindow
                :show="modal.wisdom_agri.show"
                :textTitle="wisdom_agri.select.title"
                :maxWidth="'450px'"
                @ClickClose="modal.wisdom_agri.show = false;">
                <div style="min-height: 600px;max-height: 600px; overflow-y: auto;">

                    <b-img :src="wisdom_agri.select.src" style="margin-bottom: 10px;" fluid></b-img>
                    <div class="global-descript" style="margin-bottom: 10px;">
                        <span class="global-tag badge badge-primary">單位介紹</span><br />
                        <div v-html="wisdom_agri.select.unit_introduction"></div>
                    </div>
                    <div class="global-descript" style="margin-bottom: 10px;">
                        <span class="global-tag badge badge-primary">成果介紹</span><br />
                        <div v-html="wisdom_agri.select.achievement_introduction"></div>
                    </div>
                    <div style="margin-bottom: 10px;">
                        <button type="button" class="btn btn-primary btn-block" @click="setWisdomAgriResultPhotoSelect()">查看更多相片</button>
                    </div>

                </div>
            </ModalWindow>

            <!-- 彈出視窗(智慧農業成果)(圖片) -->
            <ModalWindow
                :show="modal.wisdom_agri_photo.show"
                :textTitle="wisdom_agri.select.title"
                :maxWidth="'450px'"
                @ClickClose="modal.wisdom_agri_photo.show = false;">

                <!-- 輪播 -->
                <carousel
                    :key="wisdom_agri.select.photo.length"
                    :autoplay="false"
                    :margin="10"
                    :loop="false"
                    :nav="false"
                    :dots="true"
                    :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}"
                    v-if="wisdom_agri.select.photo != null && wisdom_agri.select.photo.length > 0 ">

                        <div v-for="(item_agri_photo, index_agri_photo) in wisdom_agri.select.photo" :key="index_agri_photo">
                            <div class="agri-result-item drop-shadow">
                                <!-- 固定高度的容器 -->
                                <div class="carousel-pic">
                                    <b-img
                                    :src="'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/' + wisdom_agri.select.sn + '/' + item_agri_photo.src"
                                    fluid
                                    ></b-img>
                                </div>
                                <div class="title" style="text-align: center;">{{ item_agri_photo.title }}</div>
                            </div>
                        </div>

                </carousel>

            </ModalWindow>

        </div>

    </div>

</template>

<script>
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import DataSource from '@/components/pwa/DataSource.vue'
import ModalWindow from '@/components/pwa/ModalWindow.vue'
import NotificationBell from '@/components/pwa/NotificationBell.vue'
import Marquee from '@/components/pwa/Marquee.vue'
import { getOrCreateDeviceId } from '@/store/modules/notification'

export default {
    data() {
        return {

            //頁首
            title:"雲林數位農業行動平台",
            alt:"雲林數位農業行動平台",
            src:"static/img/icon-192.png",


            //跑馬燈
            marquee:{
                list:[
                ]
            },

            //主體
            //氣象在地服務專區
            weather: {
                //標題
                title:"氣象在地服務專區",
                //日期
                date: "",
                //所在縣市
                place: "",
                //最高溫
                t_max: "",
                //最低溫
                t_min: "",
                //天氣圖示
                wx: "",
                //降雨機率
                pop: "",
                //查看更多
                more:true
            },
            //天氣注意、預警
            weather_alert:
            {
                list:[],
                source:{
                    title:"高雄農來訊資訊服務",
                    href:"https://agri-data.kcg.gov.tw/api.html?vp=1#"
                },
                //目前選取災害名稱
                select:"",
            },

            //智慧農場
            wisdom_farm:{
                title:"智慧農場",
                list:[],
                select:[],
                //查看更多
                more:true
            },

            //智慧農業成果
            wisdom_agri:{
                title:"智慧農業成果",
                list:[],
                select:[],
                //查看更多
                more:true,
                source:{
                    title:"雲林農業處",
                    href:"https://agriculture.yunlin.gov.tw/"
                },
            },

            //農價趨勢觀察家
            price:{
                title:"農價趨勢觀察家",
                up:{
                    title:"漲勢作物",
                    list:[]
                },
                down:{
                    title:"跌勢作物",
                    list:[]
                },
                source:{
                    title:"農業部農業資料開放平台",
                    href:"https://data.moa.gov.tw/open_detail.aspx?id=037"
                },
                //查看更多
                more:false,
                //顯示模式：'all'(全部) 或 'subscription'(個人訂閱)
                displayMode: 'all',
                //個人訂閱作物列表
                subscriptionList: [],
                //篩選後的漲勢作物（個人訂閱）
                subscribedUpList: [],
                //篩選後的跌勢作物（個人訂閱）
                subscribedDownList: []
            },
            //最新消息
            news:{
                title:"最新消息",
                /*
                list:[
                    {
                        src:"https://ws.yunlin.gov.tw/001/Upload/413/relpic/9672/290066/51905be9-64a6-48e6-a8f3-0c20f1d504d5@710x470.jpg",
                        title:"雲林縣政府農業處"
                    },
                    {
                        src:"https://ws.yunlin.gov.tw/001/Upload/413/relpic/9672/560886/7fd549e2-6f06-4913-8a86-3a1dff1774ab@710x470.png",
                        title:"2025台灣咖啡節 2025.11. 1、2、7、8、9 雲林古坑綠色隧道"
                    },
                    {
                        src:"https://ws.yunlin.gov.tw/001/Upload/413/relpic/9672/566678/864b1fb5-3a1e-4c90-8870-73a1ba07dbbc@710x470.jpg",
                        title:"114年度第六屆雲林縣智慧農業大學開始受理報名"
                    },
                    {
                        src:"https://ws.yunlin.gov.tw/001/Upload/413/relpic/9672/566338/73077388-3381-43d2-874b-59dfe98a8e30@710x470.png",
                        title:"2025第19屆雲林國際農業機械暨資材展 2025.10.25~27 雲林虎尾高鐵特定區"
                    }
                ],
                */
                list:[],
                //查看更多
                more:false
            },

            //彈出視窗
            modal:{

                //作物注意、預警
                crop_alert:{

                    //是否呈現
                    show:false,
                    //目前選取的索引值
                    index:0
                },
                //市場價格(9日折線圖)
                trade_price:{
                    //是否呈現
                    show:false,
                    //標題
                    title:" 近9日均價及成交量",
                    //作物
                    crop:"",
                },
                //天氣小幫手
                open_weather_data:{
                    //是否呈現
                    show:false,
                    //標題
                    title:"",
                    //內容
                    content:"",
                    //時間
                    time:"",
                },
                //智慧農場
                wisdom_farm:{
                    //是否呈現
                    show:false,
                    //標題
                    title:"智慧農場描述",
                    //內容
                    content:"",
                    //時間
                    time:"",
                },
                //智慧農業成果
                wisdom_agri:{
                    //是否呈現
                    show:false,
                    title:"智慧農業成果",
                },

                //智慧農業成果(圖片)
                wisdom_agri_photo:{
                    //是否呈現
                    show:false,
                    title:"智慧農業成果",
                },
            },
            month: "",
            day: "",
            hour: "day",

            //api Line身分驗證
            apiLineAuthorize: (data) => this.userRequest.post("/API/Default/LineAuthorize", data),  //Line登入專用

            //api 天氣、氣象觀測家、農價趨勢觀察家
            apiGetHome: (data) => this.userRequest.get("API/Default/WelcomeYunLin", data),

            //api 作物9日內均價、交易量
            apiGetCropTradeDay9: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/Api/index/CropTradeDay9", data),

            //api 取得智慧農場
            apiGetWisdomFarm: (data) => this.userRequest.get("/API/Default/GetWisdomFarm", data),

            //api 取得智慧農業成果
            apiGetWisdomAgriResult: (data) => this.userRequest.get("/API/Default/GetWisdomAgriResult", data),

            //api 取得一般天氣預報-雲林縣天氣小幫手
            apiGetOpenWeatherData: (data) => this.userRequest.get("https://opendata.cwa.gov.tw/fileapi/v1/opendataapi/F-C0032-029?Authorization=CWB-3C60AC39-382B-4E08-A3E3-EEAFDFDFC94A&downloadType=WEB&format=JSON", data),

            //api 取得天氣特報-各別縣市地區目前之天氣警特報情形
            apiGetWC0033001: (data) => this.userRequest.get("https://opendata.cwa.gov.tw/fileapi/v1/opendataapi/W-C0033-001?Authorization=CWB-3C60AC39-382B-4E08-A3E3-EEAFDFDFC94A&downloadType=WEB&format=JSON", data),

            //api 取得停班停課(行政院人事行政總處)
            apiGetAtomFeed33: (data) => this.userRequest.get("/API/CropSubscription/open-alert?Url=" + data.Url, data),

            //api 取得淹水(水利署)
            apiGetAtomFeed8: (data) => this.userRequest.get("/API/CropSubscription/open-alert?Url=" + data.Url, data),

            //api 建立作物訂閱通知事件
            apiCreateNotificationEventOfCropSubscription: (data) => this.userRequest.post("/API/CropSubscription/notification-events/crop-subscription-item", data),

            //api 建立淹水、停班停課、颱風通知事件
            apiCreateNotificationEventOfAlert: (data) => this.userRequest.post("/API/CropSubscription/notification-events/alert", data),

            //api 最新消息
            apiGetLatestNewsInfo: (data) => this.userRequest.get("/API/Default/LatestNewsInfo", data),
        };
    },
    created() {
        window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                            //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

        //順便補充，如果vue認不得外部定義的函式，可以藉由 window 變數
        //像是一般呼叫外部函式 是這樣 Browser.GetLocationRootUrl()
        //但在Vue要呼叫時，則是 window.Browser.GetLocationRootUrl()

        if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        PwaTitle,
        DataSource,
        ModalWindow,
        NotificationBell,
        Marquee
    },
    updated() {
    },
    mounted() {
        this.addUserActionLog({

            TokenID:sessionStorage.getItem("TokenID"),
            WebPage:"首頁",
            WebAction:"走訪"
        });
        window.addEventListener("resize", this.checkScreenWidth);

        // 站台資料、智慧農業成果
        this.FunctionToken(this.getData, {});
        this.getWisdomFarm();
        this.getWisdomAgriResult();
        // 取得個人訂閱作物
        this.getAccountCropSubscription();

        var d = new Date();
        this.month = d.getMonth() + 1;
        this.day = d.getDate();
        let hours = d.getHours();
        if (hours >= 18) this.hour = "night";

        //以下先設定為null，因為會發生換頁時，他非null執行updateOptions會報錯，所以統一初始時，幫他設定Null
        //因為Vue是用元件切換，所以在換頁時，default_chart 並不會重載，只有整個重新整理才會重載，所以換頁時時常會出現錯誤
        window.ChartCropTradeDay9 = null;
    },
    beforeUnmount() {
        // 跑馬燈現在由 Marquee 元件內部管理
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkScreenWidth); // 移除監聽器
    },
    computed: {
        // 根據跑馬燈內容字數動態計算速度
        marqueeSpeed() {
            if (this.marquee.list.length === 0) {
                return 20; // 預設速度
            }

            // 計算所有項目的總字數
            const totalChars = this.marquee.list.reduce((sum, item) => {
                return sum + (item.title ? item.title.length : 0);
            }, 0);

            // 根據總字數計算速度（每個字約 0.3-0.5 秒）
            const baseSpeed = Math.max(20, totalChars * 1);
            // console.log("totalChars:", totalChars);
            // console.log("marqueeSpeed:", baseSpeed);

            return baseSpeed;
        }
    },
    methods: {

        //點選設定
        onSetting(){

            window.location = "pwa.html#/PwaSettings";
        },
        //查看更多(氣象在地服務專區)
        moreWeather(){ window.location = "pwa.html#/PwaWeatherStation"; },
        //查看更多(智慧農場)
        moreWisdomFarm(){ window.location = "pwa.html#/PwaFarm"; },
        //查看更多(農價趨勢觀察家)
        morePrice(){ alert("查看更多(農價趨勢觀察家)"); },
        //查看更多(最新消息)
        moreNews(){ alert("查看更多(最新消息)"); },

        //左邊補0(不滿2位數)
        padLeft(str, lenght) {
            str = str.toString();
            if (str.length >= lenght)
                return str;
            else
                return this.padLeft("0" + str, lenght);
        },
        //取得 相關API資料
        async getData(data) {

            //取得最新消息
            this.apiGetLatestNewsInfo(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                console.log(json);
                this.news.list = [];
                for(var i=0 ; i < json.length ; i++)
                {
                    if(json[i].Photo.length > 0){

                        this.news.list.push({
                            title:json[i].Title,
                            src:"https://agri-plus.yunlin.gov.tw/"+json[i].Photo[0].Path,
                            url:json[i].SourceUrl 
                        });  

                    }
                    else
                    {
                        this.news.list.push({
                            title:json[i].Title,
                            src:"",
                            href:json[i].SourceUrl
                        });  
                    }

                }
            })
            .catch((err) => {
                console.log(err);
            });

            //取得一般天氣預報-雲林縣天氣小幫手
            this.apiGetOpenWeatherData(data)
            .then((res) => {

                console.log(res.data);
                //var parameterSetName = res.data.cwaopendata.dataset.parameterSet.parameterSetName;
                //var parameter = res.data.cwaopendata.dataset.parameterSet.parameter;
                //var time = this.formatDate(new Date(res.data.cwaopendata.dataset.datasetInfo.issueTime));

                var parameterSetName = res.data.cwaopendata.Dataset.DatasetInfo.DatasetDescription;
                var parameter = res.data.cwaopendata.Dataset.Locations.Location.WeatherElement.ElementValue.WeatherDescription;
                var time = this.formatDate(new Date(res.data.cwaopendata.Dataset.DatasetInfo.IssueTime));

                /*
                if(parameter.length > 0)
                {
                    this.modal.open_weather_data.title = parameterSetName;
                    for(var i=0 ; i<parameter.length ; i++)
                    {
                        this.modal.open_weather_data.content += "<p>" + parameter[i].parameterValue + "</p>";
                    }
                    this.modal.open_weather_data.content += "<p style=\"text-align: end;\">【更新時間:" + time + "】</p>";
                    this.modal.open_weather_data.show = true;
                }
                */

                if(parameter.length > 0)
                {
                    this.modal.open_weather_data.title = parameterSetName;
                    for(var i=0 ; i<parameter.length ; i++)
                    {
                        this.modal.open_weather_data.content += "<p>" + parameter[i] + "</p>";
                    }
                    this.modal.open_weather_data.content += "<p style=\"text-align: end;\">【更新時間:" + time + "】</p>";
                    // 2026-01-13 SA:暫時改成隱藏
                    this.modal.open_weather_data.show = false;
                }

            })
            .catch((err) => {
                console.log(err);
            });

            //取得天氣特報-各別縣市地區目前之天氣警特報情形
            this.apiGetWC0033001(data)
            .then((res) => {

                let location = res.data.cwaopendata.dataset.location;
                let today = new Date().toISOString().split('T')[0]; // 格式：YYYY-MM-DD
                let alertItems = []; // 用於收集通知事件

                console.log('取得天氣特報: ');
                console.log(location);

                for(var i=0 ; i<location.length ; i++)
                {
                    var item = location[i];
                    if(item.hazardConditions != null){

                        // 1. 過濾雲林縣
                        if(item.locationName.indexOf("雲林") === -1) {
                            continue;
                        }

                        var phenomena = item.hazardConditions.hazards.info.phenomena;
                        var significance = item.hazardConditions.hazards.info.significance;
                        var startTime = item.hazardConditions.hazards.validTime.startTime.replace('T', ' ').split('+')[0];
                        var endTime = item.hazardConditions.hazards.validTime.endTime.replace('T', ' ').split('+')[0];

                        // 2. 過濾當天日期（檢查開始時間是否在今天）
                        var itemDate = item.hazardConditions.hazards.validTime.startTime.split('T')[0];
                        if(itemDate !== today) {
                            continue;
                        }

                        // 符合條件，加入跑馬燈
                        var title = "[" + phenomena + "(" + significance + ")" + "]" + item.locationName + "\n" + startTime + "-" + endTime;
                        this.marquee.list.push({title: title});
                        console.log("天氣特報：", title);

                        // 3. 收集通知事件資料
                        alertItems.push({
                            Type: "Typhoon",
                            Title: phenomena + " - " + significance,
                            Summary: item.locationName + " " + phenomena,
                            Description: "時間：" + startTime + " 至 " + endTime + "\n地區：" + item.locationName + "\n內容：" + phenomena + " (" + significance + ")",
                            Updated: startTime,
                            Source: "氣象開放資料平台",
                        });
                    }
                }

                // 建立通知事件
                if(alertItems.length > 0) {
                    this.createAlertNotification(alertItems);
                }
            })
            .catch((err) => {
                console.log(err);
            });

            //天氣、氣象觀測家、農價趨勢觀察家
            this.apiGetHome(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                if (json) {
                    // 天氣
                    let weather_info = json.weather_info;               //天氣資訊
                    this.weather.date = json.date;                      //日期
                    this.weather.place = weather_info.location;         //所在縣市
                    this.weather.t_max = weather_info.t_max;            //最高溫
                    this.weather.t_min = weather_info.t_min;            //最低溫
                    this.weather.wx = this.padLeft(weather_info.wx, 2); //天氣圖示
                    this.weather.pop = weather_info.pop;                //降雨機率
                    // 農價趨勢觀察家
                    this.price.up.list = json.up_trend;                 // 漲勢作物
                    this.price.down.list = json.down_trend;             // 跌勢作物

                    // 重新篩選個人訂閱的作物
                    if(this.price.subscriptionList.length > 0) {
                        this.filterSubscribedCrops();
                    }

                    // 氣象觀測家
                    let weather_warning = json.weather_warning;
                    console.log(weather_warning);
                    const keyword = "注意";
                    const addword = "警戒";
                    const affectword = "可能影響-";
                    this.weather_alert.list = [];// 氣象觀測家
                    for (let i = 0; i < weather_warning.length; i++) {
                        let detail = weather_warning[i].list;
                        let temp = { disaster: '', affect: '', color: '', datas: [] };
                        let disaster = weather_warning[i].disaster;
                        if (disaster.indexOf(keyword) !== -1) {
                            temp.disaster = disaster;
                            temp.color = "warning";
                        }
                        else {
                            temp.disaster = disaster + addword;
                            temp.color = "danger";
                        }

                        for (let j = 0; j < detail.length; j++) {
                            let tempdetail = { crop: '', content: '' };
                            if (j == 0) {
                                if (disaster.indexOf(keyword) !== -1) {
                                    temp.affect = affectword + detail[j].disaster;
                                }
                                else {
                                    temp.affect = affectword + detail[j].disaster + addword;
                                }
                            }

                            tempdetail.crop = detail[j].crop;
                            tempdetail.crop_id = detail[j].crop_id;
                            tempdetail.note = detail[j].note;
                            tempdetail.disaster = detail[j].disaster;
                            tempdetail.period = detail[j].period;
                            tempdetail.time = detail[j].time;
                            tempdetail.duration = detail[j].duration;
                            tempdetail.threshold = detail[j].threshold;
                            tempdetail.unit = detail[j].unit;
                            tempdetail.effect = detail[j].effect;
                            tempdetail.prevention = detail[j].prevention;
                            tempdetail.recovery = detail[j].recovery;
                            tempdetail.contact_name = detail[j].contact_name;
                            tempdetail.contact_tel = detail[j].contact_tel;
                            tempdetail.contact_url = detail[j].contact_url;
                            tempdetail.content = detail[j].effect;

                            temp.datas.push(tempdetail);
                        }
                        this.weather_alert.list.push(temp);
                    }
                    this.weather_alert.select = this.weather_alert.list[0].disaster; // 設定 氣象觀測家
                }
                else { console.log('NO'); }
            })
            .catch((err) => {
                console.log(err);
            });

            // 取得停班停課(行政院人事行政總處)，完成後再取得淹水警報
            await this.fetchAtomFeed33();
            await this.fetchAtomFeed8();
        },

        //api 作物9日內均價、交易量
        getCropTradeDay9(crop) {

            this.enableMask();
            this.modal.trade_price.crop = crop;
            this.modal.trade_price.show = true;
            this.apiGetCropTradeDay9({

                CROP: this.modal.trade_price.crop ,
            })
            .then((res)=>{

                //var data = JSON.parse(res.data);
                //如果直接抓高雄的資料，則無需轉成json
                const data = res.data;
                if(data.length > 0)
                {
                    var column_week = [];
                    var line_week = [];
                    for(var i=0 ; i< data.length ; i++)
                    {
                        column_week.push({
                            //交易日期
                            x:data[i].T_DATE,
                            //交易量
                            y:this.getRounded(data[i].VOLUME)
                        });

                        line_week.push({
                            //交易日期
                            x:data[i].T_DATE,
                            //均價
                            y:this.getRounded(data[i].AVG)
                        });
                    }

                    window.ThreadTool.Delay(function(){

                        window.setChartCropTradeDay9("#chart_crop_trade_day9",{
                            column:column_week,
                            line:line_week
                        });

                    },1500);
                }

                this.disableMask();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //取得智慧農場
        getWisdomFarm:function()
        {
            this.soil = [];
            this.apiGetWisdomFarm({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                console.log(list);
                this.wisdom_farm.list = [];
                for(var i=0;i < list.length ; i++){

                    var item = list[i];
                    this.wisdom_farm.list.push({
                        title:item.name,
                        src:'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + item.sn + '/' + item.cover,
                        url:'FarmDetail/' + item.sn,
                        descript:item.descript,
                        device_id:item.device_id,
                        list:item.list,
                        sn:item.sn
                    });
                    console.log(item.name);
                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得智慧農業成果
        getWisdomAgriResult:function()
        {
            this.apiGetWisdomAgriResult({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                console.log(list);
                this.wisdom_agri.list = [];

                for(var i=0; i<list.length ; i++)
                {
                    var item = list[i];
                    this.wisdom_agri.list.push({

                        src:"https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + item.sn + "/" + item.cover,
                        sn:item.sn,
                        title:item.name,
                        year:item.year,
                        benefit:item.save_labour,
                        target:item.question,
                        strategy:item.solution,
                        city:item.town,
                        unit_introduction:item.unit_introduction,
                        achievement_introduction:item.achievement_introduction,
                        photo:item.photo,
                    });
                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //設定示範場域(已選擇)
        //取得個人訂閱作物
        getAccountCropSubscription:function()
        {
            this.FunctionToken(this.callGetAccountCropSubscriptionAPI, {});
        },

        //調用取得個人訂閱作物 API
        callGetAccountCropSubscriptionAPI:function(data)
        {
            // console.log("調用訂閱作物API，參數：", data);
            this.userRequest.get('/API/CropSubscription/account-items', {
                params: {
                    TokenID: data.TokenID,
                    Token: data.Token
                }
            })
            .then((res)=>{
                const result = res.data || [];
                // console.log("訂閱作物：", result);

                // 儲存訂閱作物列表
                this.price.subscriptionList = result;

                // 篩選個人訂閱的漲跌作物
                this.filterSubscribedCrops();

                // 如果有訂閱作物，預設顯示個人訂閱模式
                if(this.price.subscriptionList.length > 0) {
                    this.price.displayMode = 'subscription';
                }
            })
            .catch((err)=> {
                console.log("取得訂閱作物失敗：", err);
                // 失敗時保持顯示全部
                this.price.displayMode = 'all';
            });
        },

        //篩選個人訂閱的漲跌作物
        filterSubscribedCrops:function()
        {
            // 取得訂閱作物的名稱列表
            // const subscribedCropNames = this.price.subscriptionList.map(item => item.DisplayName)

            // 取得訂閱作物的解析後農情代碼
            const subscribedCropIds = this.price.subscriptionList.map(item => item.AnalysisCropId)

            // console.log("訂閱作物名稱：", subscribedCropNames)
            // console.log("訂閱作物：", subscribedCropIds)

            // 篩選漲勢作物
            this.price.subscribedUpList = this.price.up.list.filter(crop =>
                // subscribedCropNames.includes(crop.crop)
                subscribedCropIds.includes(crop.c_id)
            );

            // 篩選跌勢作物
            this.price.subscribedDownList = this.price.down.list.filter(crop =>
                // subscribedCropNames.includes(crop.crop)
                subscribedCropIds.includes(crop.c_id)
            );

            // console.log("訂閱漲勢作物：", this.price.subscribedUpList)
            // console.log("訂閱跌勢作物：", this.price.subscribedDownList)

            // 如果有訂閱的漲勢或跌勢作物，建立通知事件
            if(this.price.subscribedUpList.length > 0 || this.price.subscribedDownList.length > 0) {
                this.createCropSubscriptionNotification();
            }
        },

        //建立作物訂閱通知事件
        createCropSubscriptionNotification:function()
        {
            this.FunctionToken(this.callCreateCropSubscriptionNotificationAPI, {});
        },

        //調用建立作物訂閱通知事件 API
        async callCreateCropSubscriptionNotificationAPI(data)
        {
            // 提取漲勢作物（包含名稱和均價）
            const upTrendCropNames = this.price.subscribedUpList.map(item => ({
                CropName: item.crop,
                AvgPrice: item.avg
            }));

            // 提取跌勢作物（包含名稱和均價）
            const downTrendCropNames = this.price.subscribedDownList.map(item => ({
                CropName: item.crop,
                AvgPrice: item.avg
            }));

            // console.log("建立通知事件 - 漲勢作物：", upTrendCropNames);
            // console.log("建立通知事件 - 跌勢作物：", downTrendCropNames);

            // 取得 DeviceId（訪客模式，會等待 Cordova device ready）
            const deviceId = await getOrCreateDeviceId();

            this.apiCreateNotificationEventOfCropSubscription({
                TokenID: data.TokenID,
                Token: data.Token,
                DeviceId: deviceId,
                UpTrendCropNames: upTrendCropNames,
                DownTrendCropNames: downTrendCropNames
            })
            .then((res)=>{
                const result = res.data;
                // console.log("建立通知事件結果：", result);

                if(result.Success) {
                    if(result.Data.IsCreated) {
                        // console.log("成功建立通知事件，EventId：", result.Data.EventId);
                        // 刷新通知鈴鐺的數據
                        this.refreshNotificationBell();
                    } else {
                        // console.log("通知事件已存在，未重複建立");
                    }
                }
            })
            .catch((err)=> {
                console.log("建立通知事件失敗：", err);
            });
        },

        //刷新通知鈴鐺
        refreshNotificationBell:function()
        {
            // 檢查 NotificationBell 組件是否已掛載
            if (this.$refs.notificationBell) {
                this.$refs.notificationBell.loadNotifications();
                console.log("已刷新通知鈴鐺數據");
            }
        },

        //建立警報通知事件（淹水、停班停課、颱風）
        createAlertNotification:function(alertItems)
        {
            this.FunctionToken(this.callCreateAlertNotificationAPI, { alertItems: alertItems });
        },

        //調用建立警報通知事件 API
        async callCreateAlertNotificationAPI(data)
        {
            console.log("建立警報通知事件，項目數：", data.alertItems.length);

            // 取得 DeviceId（訪客模式，會等待 Cordova device ready）
            const deviceId = await getOrCreateDeviceId();

            this.apiCreateNotificationEventOfAlert({
                TokenID: data.TokenID,
                Token: data.Token,
                DeviceId: deviceId,
                AlertItem: data.alertItems
            })
            .then((res)=>
            {
                const result = res.data;
                console.log("建立警報通知事件結果：", result);

                if(result.Success) {
                    if(result.Data.CreatedCount > 0) {
                        console.log("成功建立 " + result.Data.CreatedCount + " 筆警報通知事件");
                        // 刷新通知鈴鐺的數據
                        this.refreshNotificationBell();
                    } else {
                        console.log("所有警報通知事件已存在，未重複建立");
                    }
                }
            })
            .catch((err)=>
            {
                console.log("建立警報通知事件失敗：", err);
            });
        },

        //取得停班停課（行政院人事行政總處）
        fetchAtomFeed33:function()
        {
            return this.apiGetAtomFeed33({
                    Url: "https://alerts.ncdr.nat.gov.tw/JSONAtomFeed.ashx?AlertType=33",
                })
                .then((res) => {

                    let data = res.data.Data

                    let entry = data.entry;
                    let today = new Date().toISOString().split('T')[0]; // 格式：YYYY-MM-DD
                    let alertItems = []; // 用於收集通知事件

                    console.log('停班停課:')
                    console.log(entry)

                    for (var i = 0; i < entry.length; i++) {
                        let item = entry[i];
                        let summaryText = item.summary["#text"];
                        let updated = item.updated

                        // 1. 過濾雲林縣
                        if (summaryText.indexOf("雲林") === -1) {
                            continue;
                        }

                        // 2. 過濾當天日期
                        let itemDate = "";
                        if (updated) {
                            itemDate = updated.split('T')[0];
                        }
                        if (itemDate !== today) {
                            continue;
                        }

                        // 取出縣市名稱（格式：停班停課通知]雲林縣: ...）
                        let cityName = "雲林縣";
                        try {
                            // 提取 ] 和 : 之間的縣市名稱
                            let parts = summaryText.split(']');
                            if (parts.length > 1) {
                                let cityPart = parts[1].split(':')[0];
                                if (cityPart) {
                                    cityName = cityPart.trim();
                                }
                            }
                        } catch (e) {
                            console.log("提取縣市名稱失敗：", e);
                        }

                        // 符合條件，加入跑馬燈
                        let marqueeTitle = summaryText.replaceAll("[停班停課通知]", "[停班停課]");
                        this.marquee.list.push({title: marqueeTitle});
                        // console.log("停班停課（雲林）：", summaryText, "縣市：", cityName);

                        // 3. 收集通知事件資料
                        alertItems.push({
                            Type: "StopWork",
                            Title: "停班停課通知 - " + cityName,
                            Summary: summaryText.replaceAll("[停班停課通知]", ""),
                            Description: summaryText,
                            Updated: updated,
                            Source: "民生示警公開資料平台",
                        });
                    }

                    // 建立通知事件
                    if (alertItems.length > 0) {
                        this.createAlertNotification(alertItems);
                    }

                })
                .catch((err) => {
                    console.log(err);
                });
        },

        //取得淹水警報（水利署）
        fetchAtomFeed8:function()
        {
            return this.apiGetAtomFeed8({
                    Url: "https://alerts.ncdr.nat.gov.tw/JSONAtomFeed.ashx?AlertType=8",
                }
            )
            .then((res) => {
                let data = res.data.Data
                let entry = data.entry;
                let today = new Date().toISOString().split('T')[0]; // 格式：YYYY-MM-DD
                let alertItems = []; // 用於收集通知事件

                console.log('取得淹水警報:');
                console.log(data)

                if (entry) {
                    for (var i = 0; i < entry.length; i++) {
                        var item = entry[i];
                        var summaryText = item.summary["#text"].replaceAll(" ", "").replaceAll("\n", "");
                        var updated = item.updated

                        // 1. 過濾雲林縣
                        if (summaryText.indexOf("雲林") === -1) {
                            continue;
                        }

                        // 2. 過濾當天日期
                        var itemDate = "";
                        if (updated) {
                            itemDate = updated.split('T')[0];
                        }
                        if (itemDate !== today) {
                            continue;
                        }

                        // 符合條件，加入跑馬燈
                        var marqueeTitle = "[淹水]" + summaryText;
                        this.marquee.list.push({title: marqueeTitle});
                        console.log("淹水警報：", summaryText);

                        // 3. 收集通知事件資料
                        alertItems.push({
                            Type: "Flood",
                            Title: "淹水警報",
                            Summary: summaryText,
                            Description: summaryText,
                            Updated: updated,
                            Source: "民生示警公開資料平台",
                        });
                    }

                    // 建立通知事件
                    if (alertItems.length > 0) {
                        this.createAlertNotification(alertItems);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //切換顯示模式（全部/個人訂閱）
        togglePriceDisplayMode:function()
        {
            if(this.price.displayMode === 'all') {
                // 如果有訂閱作物才能切換到訂閱模式
                if(this.price.subscriptionList.length > 0) {
                    this.price.displayMode = 'subscription'
                }
            } else {
                this.price.displayMode = 'all'
            }
        },

        //設定天氣注意、預警(取得相關作物)
        setWisdomFarmSelect(select) {
            console.log(select);
            this.wisdom_farm.select = select;
            this.modal.wisdom_farm.show = true;
        },

        //設定智慧農業成果(已選擇)
        setWisdomAgriResultSelect(select) {

            this.wisdom_agri.select = select;
            this.modal.wisdom_agri.show = true;
        },

        //智慧農業成果(圖片)(已選擇)
        setWisdomAgriResultPhotoSelect() {

            this.modal.wisdom_agri_photo.show = true;
        },

        //設定天氣注意、預警(取得相關作物)
        setWeatherAlertSelect(select, type) {
            this.modal.crop_alert.show = true;
            if (type == 'data') {
                this.weather_alert.select = select;
                this.modal.crop_alert.index = 0;
            }
            else
            {
                this.modal.crop_alert.index = select;
            }
        },

        //日期及時間修正，如果不到2位數，則補0
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        //時間轉換字串 (格式:yyyy-mm-dd hh:mm:ss)
        formatDate(date) {
            return (
                [
                date.getFullYear(),
                this.padTo2Digits(date.getMonth() + 1),
                this.padTo2Digits(date.getDate()),
                ].join('-') +
                ' ' +
                [
                this.padTo2Digits(date.getHours()),
                this.padTo2Digits(date.getMinutes()),
                this.padTo2Digits(date.getSeconds()),
                ].join(':')
            );
        },

        //取得作物預警 門檻
        getCropAlertThreshold:function(val){

            var str = "";
            switch (val.disaster)
            {
                case "颱風":
                str = "發佈陸上颱風警報";
                break;
                case "焚風":
                    str = "相對濕度比前一小時減少10%以上，溫度增加一度以上，且溫度>34℃，相對濕度<54%";
                break;
                case '降水':
                case "霪雨":
                case "梅雨":
                str = "過去" + val.duration + "小時，累積雨量高於" + val.threshold + "mm";
                break;
                case "乾旱":
                str = "過去" + val.duration/24 + "天，累積雨量低於" + val.threshold + "mm";
                break;
                case "高溫":
                str = "過去" + val.duration + "小時，平均溫度高於" + val.threshold + "℃";
                break;
                case "寒害":
                str = "過去" + val.duration + "小時，平均溫度低於" + val.threshold + "℃";
                break;
                case "注意高溫":
                str = "未來7天，預測溫度高於" + val.threshold + "℃";
                break;
                case "注意寒害":
                str = "未來7天，預測溫度低於" + val.threshold + "℃";
                break;
                case "注意回溫":
                str = "未來7天，預測日升溫高於" + val.threshold + "℃";
                break;
                case "注意降溫":
                str = "未來7天，預測日降溫低於" + val.threshold + "℃";
                break;
                case "注意霪雨":
                case "注意梅雨":
                str = "未來7天，有可能持續降雨";
                break;
                case "注意颱風":
                str = "發佈海上颱風警報";
                break;

                default:
            }
            return str;
        },

    },
    watch: {
    }
};
</script>

<style scoped>

    /** 作物9日內均價、交易量 */
    #chart_crop_trade_day9{
        min-width: 600px;
    }
    .w3-modal{
        padding-top: 10rem;
    }


    .marquee-container {
        width: 100%;
        margin-bottom: 10px;
    }

    .marquee-container ::v-deep .marquee-wrapper {
        background: #17A8B2;  /* 藍綠色 */
        border-radius: 0;
        box-shadow: none;
    }

    .marquee-container ::v-deep .marquee-text {
        color: #FFFFFF;  /* 白色 */
        font-weight: bold;
    }

    /* 水平滾動項目文字顏色 */
    .marquee-container ::v-deep .marquee-item {
        color: #FFFFFF;  /* 白色 */
    }

    /* 分隔符顏色 */
    .marquee-container ::v-deep .marquee-item::after {
        color: #036EB8 !important;  /* 分隔符 */
    }

</style>

